import type * as React from "react";
import cn from "twsx";
import { Text } from "@/components/ui/Text";
import styles from "./List.module.css";

// A selectable feed row (inbox): 60px, list-row radius and hover fill; the
// selected row keeps the hover fill. `pending` dims it while an action runs.
/** Use when a feed lists selectable items, such as an inbox. */
export function ListItemButton({
  selected = false,
  pending = false,
  className,
  ...props
}: Omit<React.ComponentProps<"button">, "type"> & { selected?: boolean; pending?: boolean }) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={cn(
        styles.itemButton,
        "flex w-full min-w-0 flex-1 items-center gap-3 rounded-lg px-2.5 py-2 text-left outline-none",
        pending && "cursor-wait opacity-70",
        className,
      )}
      {...props}
    />
  );
}

// A labelled group of feed rows (Today, Yesterday, Earlier), with its count when given.
export function ListItemGroup({ label, count, children }: { label: string; count?: number; children: React.ReactNode }) {
  return (
    <section aria-label={label} className="flex flex-col">
      <div className="flex h-7 items-center justify-between px-2">
        <Text size="xs" weight="medium" tone="quaternary">{label}</Text>
        {count !== undefined && <Text size="xs" weight="medium" tone="quaternary" numeric>{count}</Text>}
      </div>
      <div className="flex flex-col gap-0.5">{children}</div>
    </section>
  );
}
